// https://api.openweathermap.org/data/2.5/weather?q=jaipur&appid=626e22e9d3f5a7bf41b8a61964ae9871
import React, {useEffect, useState} from 'react'
import "./style.css"
import Weathercard from './weathercard';

const Temp = () => {
    const [searchValue, setSearchValue] = useState("jaipur");
    const [tempInfo, setTempInfo] = useState({});

    const getWeatherInfo = async () => {
        try {
            let url = `https://api.openweathermap.org/data/2.5/weather?q=${searchValue}&units=metric&appid=626e22e9d3f5a7bf41b8a61964ae9871`;
            const res = await fetch(url);
            const data = await res.json();

            const {temp, humidity, pressure} = data.main;
            const {main: weathermood} = data.weather[0];
            const {name} = data;
            const {speed} = data.wind;
            const {country, sunset} = data.sys;
            const myNewWeatherInfo = {
                temp,
                humidity,
                pressure,
                weathermood,
                name,
                speed,
                country,
                sunset,
            };
            setTempInfo(myNewWeatherInfo);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getWeatherInfo();
    }, []);

  return (
    <>
        <div className='wrap'>
            <div className='search'>
                <input 
                    type="search"
                    placeholder='Search...'
                    autoFocus
                    id='search'
                    className='searchTerm'
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
                <button className='searchButton' type='button' onClick={getWeatherInfo}>
                    Search
                </button>
            </div>
        </div>
        {/* temp card */}
        <Weathercard tempInfo={tempInfo} />
    </>
  )
}

export default Temp